import { Link } from '@mui/material';

export const getTagsFromText = (messages: string[][]): (string | JSX.Element)[] => messages
  .map((message: string[]) => {
    switch (message[0]) {
      case 'strong':
        return <strong>{message[1]}</strong>;
      case 'link':
        return <Link href={`https://${message[1]}`} underline="none" target="_blank">{message[1]}</Link>;
      case 'email':
        return <Link href={`mailto:${message[1]}?`} underline="none">{message[1]}</Link>;
      case 'icon':
        return `<${message[1]} style={{ verticalAlign: 'top', fontSize: '17px', padding: '2px' }} />`;
      case 'br':
        return <br />;
      default:
        return message[0];
    }
  }).map(
    (
      messageFormatted: string | JSX.Element,
      index: number,
    ) => (typeof (messageFormatted) === 'string'
      ? messageFormatted
      : { ...messageFormatted, key: `${index}key` }),
  );
